import React, { Component } from 'react'
import Calendar from './Calendar'
import Info from './Info'
import Operation from './Operation'
import Modal from './Modal'
import Style from './style.module.less'
import { observer } from 'mobx-react'
import Store from './store'
import TopTip from './TopTip'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store(props.isTeamSchedule)
  }
  render() {
    return (
      <>
        <TopTip store={this.store} />
        <div className={Style.panel}>
          <div className={Style['panel-left']}>
            <Calendar store={this.store} />
          </div>
          <div className={Style['panel-right']}>
            <Info store={this.store} />
          </div>
        </div>
        <Operation store={this.store} />
        <Modal store={this.store} />
      </>
    )
  }
}
